export const processData = [
    {
        key: 1,
        id: 'concept',
        name: 'Professional Desktop & Website & Mobile Design',
        img: 'https://i.imgur.com/rwUzqbI.jpg',
        title: 'We sit down with you to determine what is going to be the best implementation routes for design, development and security. We ensure we map out the entire process for you.',
        link: '/',

    },
    {
        key: 2,
        id: 'prototyping',
        name: 'Mock ups or Physical Tech',
        img: 'https://i.imgur.com/rwUzqbI.jpg',
        title: 'After conceptualizing your project will give you a rough example of your product so you can visiualize your project.',
        link: '/',

    },
    {
        key: 3,
        id: 'design',
        name: 'UX/UI is Essential',
        img: 'https://i.imgur.com/rwUzqbI.jpg',
        title: 'Look and feel is important! We send a lot of time looking into design patterns, color theory and typeography to enhance your user experience and how professional your project looks.',
        link: '/',

    },
    {
        key: 4,
        id: 'development',
        name: 'Algorithms, Data Structures, Security, & Delopyment',
        img: 'https://i.imgur.com/rwUzqbI.jpg',
        title: 'This process gets down to the barebones of your project. We use the best algorithms and data structures to ensure your memory and storage is being properly utilized. Wait, what does that mean PERFORMANCE (faster applications). And lastly, security and development we all know how important security is. We use the latest security and delopyment practices. ',
        link: '/',

    },

]